const isActiveRoute = (location, route) => {
  if (route.isRoot) {
    const index = location.pathname.lastIndexOf(route.href)
    const lastCharIndex = location.pathname.length - 1
    return index === lastCharIndex
  }
  return location.pathname.includes(route.href)
}

export default isActiveRoute